import React, { useState, useEffect } from "react";
import axios from 'axios';
import Sidennav from '../dashboard/sidenavbar';
import Topnavbar from '../dashboard/topnavbar';
import { baseurladdress } from "../baseurl";
import * as $ from 'jquery';
import { useNavigate } from "react-router-dom";
import { NavLink } from "react-router-dom";


export default function AddStaff() {
    const accesstoken = localStorage.getItem("token");
    const accessuserid = localStorage.getItem("id");
    const Swal = require('sweetalert2')

    let navigate = useNavigate();

    const [branch_name, setbranch_name] = useState([]);
    const [cntry_name, setcntry_name] = useState([]);
    const [state_name, setstate_name] = useState([]);
    const [district_name, setdistrict_name] = useState([]);
    const [dept, setdept] = useState([]);
    const [shifttype, setshifttype] = useState([]);

    const [Staffname, setStaffname] = useState("");
    const [Staffbranch, setStaffbranch] = useState("");
    const [StaffCode, setStaffCode] = useState("");
    const [branchCodeMap, setBranchCodeMap] = useState({});

    // Auto-generate staff code when staff name or branch changes
    useEffect(() => {
        if (Staffname.trim() !== "" && Staffbranch) {
            const namePrefix = Staffname.trim().substring(0, 3).toUpperCase();
            const branchName = branchCodeMap[Staffbranch] || "";
            const branchCode = branchName.trim().substring(0, 3).toUpperCase();
            const randomNum = String(Math.floor(1000 + Math.random() * 9000));
            const code = namePrefix + "-" + branchCode + "-" + randomNum;
            setStaffCode(code);
        } else if (Staffname.trim() !== "" && !Staffbranch) {
            const randomNum = String(Math.floor(1000 + Math.random() * 9000));
            const code = Staffname.trim().substring(0, 3).toUpperCase() + randomNum;
            setStaffCode(code);
        } else {
            setStaffCode("");
        }
    }, [Staffname, Staffbranch, branchCodeMap]);
    const [Staffdob, setStaffdob] = useState("");
    const [Staffgender, setStaffgender] = useState("");
    const [Staffmobile, setStaffmobile] = useState("");
    const [Staffphone, setStaffphone] = useState("");
    const [Staffemail, setStaffemail] = useState("");
    const [Staffbriefnote, setStaffbriefnote] = useState("");
    const [staffjoiningdate, setStaffjoiningdate] = useState("");
    const [Stafffathername, setStafffathername] = useState("");
    const [Staffspousename, setStaffspousename] = useState("");
    const [Staffdooraddress, setStaffdooraddress] = useState("");
    const [Staffstreet, setStaffstreet] = useState("");
    const [Staffplace, setStaffplace] = useState("");
    const [Staffcountry, setStaffcountry] = useState("");
    const [Staffstate, setStaffstate] = useState("");
    const [Staffdistrict, setStaffdistrict] = useState("");
    const [Staffpincode, setStaffpincode] = useState("");

    const [Staffdept, setStaffdept] = useState("");
    const [stypes, setstypes] = useState("");
    //SUBMIT STAFF 👇

    const handleSubmit = (event) => {

        event.preventDefault();
        const data = {

            staff_name: Staffname,
            staff_code: StaffCode,
            staff_dob: Staffdob,
            staff_gender: Staffgender,
            staff_mobile: Staffmobile,
            staff_phone: Staffphone,
            staff_email: Staffemail,
            staff_brief: Staffbriefnote,
            staff_joinedon: staffjoiningdate,
            staff_father: Stafffathername,
            staff_spouse: Staffspousename,
            staff_door: Staffdooraddress,
            staff_street: Staffstreet,
            staff_place: Staffplace,
            staff_cntry: Staffcountry,
            staff_state: Staffstate,
            staff_district: Staffdistrict,
            staff_placedat: Staffbranch,
            staff_pin: Staffpincode,
            staff_department: Staffdept,
            staff_branchshift: stypes,
            userid: accessuserid
        };


        fetch(
            baseurladdress + `addstaff`,
            {
                method: "POST",

                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accesstoken}`,
                },
            }
        )
            .then((res) => res.json())
            .then((result) => {
                if (result["status"] === "success") {

                    //alert("Staff added successfully");
                    const Toast = Swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 1800,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', Swal.stopTimer)
                            toast.addEventListener('mouseleave', Swal.resumeTimer)
                        }
                    })
                    Toast.fire({
                        icon: 'success',
                        title: 'Staff added successfully'
                    })
                    //window.location.href = "/stafflist";
                    navigate("/stafflist");
                }
            });
    };




    //GET BRANCH LISTS👇

    useEffect(() => {
        const getbranch = () => {
            axios.get(baseurladdress + `getallbranchs`, {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
                .then(res => {
                    const data = res.data.response;
                    // console.log(data);
                    const user = data.map((item, index) => {
                        return (
                            <option value={item.branch_id}> {item.branch_name} </option>
                        )
                    }
                    );
                    setbranch_name(user);
                    // Build branch code lookup map using branch_code from API
                    const codeMap = {};
                    data.forEach(item => {
                        codeMap[item.branch_id] = item.branch_code || item.branch_name || "";
                    });
                    setBranchCodeMap(codeMap);
                }).catch(error => {
                    alert(error);
                })
        }
        getbranch()

        const getcountry = () => {
            axios.get(baseurladdress + `getallcountries`, {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
                .then(res => {
                    const data = res.data.response;
                    // console.log(data);
                    const user = data.map((item, index) => {
                        return (
                            <option value={item.cntry_id}> {item.cntry_name} </option>
                        )
                    }
                    );
                    setcntry_name(user);
                }).catch(error => {
                    alert(error);
                })
        }
        getcountry()


        const getdept = () => {
            axios.get(baseurladdress + `getalldepts`, {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
                .then(res => {
                    const data = res.data.response;
                    // console.log(data);
                    const dept = data.map((item, index) => {
                        return (
                            <option value={item.dept_id}> {item.dept_name} </option>
                        )
                    }
                    );
                    setdept(dept);
                }).catch(error => {
                    alert(error);
                })
        }
        getdept()



        const getshifttype = () => {
            axios.get(baseurladdress + `getallshifttype`, {
                headers: { Authorization: `Bearer ${accesstoken}` },
            })
                .then(res => {
                    const data = res.data.response;
                    // console.log(data);
                    const shifttype = data.map((item, index) => {
                        return (
                            <option value={item.type_id}> {item.type_name} </option>
                        )
                    }
                    );
                    setshifttype(shifttype);
                }).catch(error => {
                    alert(error);
                })
        }
        getshifttype()


    }, [])


    const changeTitle = (staffcntry) => {
        axios.get(baseurladdress + `getstates/` + staffcntry, {
            headers: { Authorization: `Bearer ${accesstoken}` },
        })
            .then(res => {
                const data = res.data.response;
                // console.log(data);
                const user = data.map((item, index) => {
                    return (
                        <option value={item.state_id}> {item.state_name} </option>
                    )
                }
                );
                setstate_name(user);
            }).catch(error => {
                alert(error);
            })
    }

    const changeDistricts = (staffdistrict) => {
        axios.get(baseurladdress + `getdistricts/` + staffdistrict, {
            headers: { Authorization: `Bearer ${accesstoken}` },
        })
            .then(res => {
                const data = res.data.response;
                // console.log(data);
                const user = data.map((item, index) => {
                    return (
                        <option value={item.district_id}> {item.district_name} </option>
                    )
                }
                );
                setdistrict_name(user);
            }).catch(error => {
                alert(error);
            })
    }









    return (
        <>
            <Topnavbar />,
            <Sidennav />,

            <div class="content-wrap" style={{ overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                <div className="container-fluid">
                    <NavLink activeClassName="active-link" to={"/stafflist"}>
                        <div style={{ display: "flex" }}>
                            <a class="float ">
                                <i class="fa fa-arrow-left my-float" style={{ "marginTop": "21px" }}></i>
                            </a>
                        </div>
                    </NavLink>
                    <form onSubmit={handleSubmit}>
                        <div className='row'>
                            <div className='row'>

                                <div class="col-xl-6 col-xxl-12">
                                    <div class="card">
                                        <div class="card-header">
                                            <h4 class="card-title">ADD STAFF</h4>
                                        </div>

                                        <div class="card-body">
                                            <div class="basic-form" >

                                                <div class="form-row">

                                                    <div class="col-sm-5">
                                                        <h6><span style={{ "color": "red" }}>*</span>Staff name </h6>
                                                        <input type="text" class="form-control" placeholder="Staff Name" onChange={(e) => setStaffname(e.target.value)} required />
                                                    </div>
                                                    <div class="col-sm-3 mt-2 mt-sm-0">
                                                        <h6><span style={{ "color": "red" }}>*</span>Staff Code </h6>
                                                        <input type="text" class="form-control" placeholder="Staff Code" value={StaffCode} readOnly required />
                                                    </div>

                                                    <div class="col-sm-4 mt-2 mt-sm-0">
                                                        <h6><span style={{ "color": "red" }}>*</span>Staff Department </h6>
                                                        <select
                                                            className="form-control select"
                                                            name="Department"
                                                            onChange={e => { setStaffdept(e.target.value) }}
                                                            required
                                                        >
                                                            <option value="" disabled selected>
                                                                Select
                                                            </option>
                                                            {dept}
                                                        </select>
                                                    </div>

                                                    <div class="col-sm-4 mt-2 mt-sm-0">
                                                        <h6><span style={{"color":"red"}}>*</span>Staff Shift </h6>
                                                        <select
                                                            className="form-control select"
                                                            name="Shift"
                                                            onChange={e => { setstypes(e.target.value) }}
                                                            required
                                                        >
                                                            <option value="" disabled selected>
                                                                Select
                                                            </option>
                                                            {shifttype}
                                                        </select>
                                                    </div>
                                                    <div class="col-sm-4 mt-2 mt-sm-0">
                                                        <h6><span style={{"color":"red"}}>*</span>DOB </h6>
                                                        <input
                                                            type="date"
                                                            className="form-control"
                                                            onChange={(e) => setStaffdob(e.target.value)}
                                                            required
                                                        />
                                                    </div>

                                                    <div class="col-sm-4 mt-2 mt-sm-0">
                                                        <h6>Gender </h6>
                                                        <select
                                                            className="form-control select"
                                                            name="employee"
                                                            id="employee"
                                                            placeholder="Enter Role"
                                                            onChange={(e) => setStaffgender(e.target.value)}
                                                        >

                                                            <option value="" disabled selected>
                                                                select
                                                            </option>
                                                            <option value="1">
                                                                Male
                                                            </option>
                                                            <option value="2">
                                                                Female
                                                            </option>
                                                            <option value="3">
                                                                Other
                                                            </option>
                                                        </select>

                                                    </div>
                                                    <div class="col-sm-4 mt-2 mt-sm-0">
                                                        <h6><span style={{"color":"red"}}>*</span>Mobile </h6>
                                                        <input class="form-control" placeholder="Mobile Number" required pattern="[0-9]+" minLength="10" maxLength="14" onChange={(e) => setStaffmobile(e.target.value)} />
                                                    </div>
                                                    <div class="col-sm-4 mt-2 mt-sm-0">
                                                        <h6>Phone </h6>
                                                        <input class="form-control" placeholder="Contact Number" pattern="[0-9]+" minLength="10" maxLength="14" onChange={(e) => setStaffphone(e.target.value)} />
                                                    </div>
                                                    <div class="col-sm-4 mt-2 mt-sm-0">
                                                        <h6><span style={{"color":"red"}}>*</span>Email </h6>
                                                        <input type="email" class="form-control" placeholder="Email ID" required pattern="^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$"
                                                            onChange={(e) => setStaffemail(e.target.value)} />
                                                    </div>

                                                    <div class="form-group col-md-12">
                                                        <h6>Brief </h6>
                                                        <textarea class="form-control text textaddstaff" placeholder="Brief" onChange={(e) => setStaffbriefnote(e.target.value)} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-6 col-xxl-12">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="basic-form">
                                                <div class="form-row">
                                                    <div class="col-sm-4 mt-2 mt-sm-0">
                                                        <h6>Joining Date</h6>
                                                        <input type="date" class="form-control" onChange={(e) => setStaffjoiningdate(e.target.value)} />
                                                    </div>
                                                    <div class="col-sm-4 mt-2 mt-sm-0">
                                                        <h6>Father name </h6>
                                                        <input type="text" class="form-control" placeholder="Father Name" onChange={(e) => setStafffathername(e.target.value)} />
                                                    </div>
                                                    <div class="col-sm-4 mt-2 mt-sm-0">
                                                        <h6>Spouse name </h6>
                                                        <input type="text" class="form-control" placeholder="Husband / Wife Name" onChange={(e) => setStaffspousename(e.target.value)} />
                                                    </div>
                                                    <div class="form-group col-md-12">
                                                        <h6>Door </h6>
                                                        <textarea class="form-control text textaddstaff" placeholder="Door" onChange={(e) => setStaffdooraddress(e.target.value)} />
                                                    </div>
                                                    <div class="col-sm-4 mt-2 mt-sm-0">
                                                        <h6><span style={{"color":"red"}}>*</span>Street </h6>
                                                        <input type="text" class="form-control" placeholder="Street" onChange={(e) => setStaffstreet(e.target.value)} />
                                                    </div>
                                                    <div class="col-sm-4 mt-2 mt-sm-0">
                                                        <h6><span style={{"color":"red"}}>*</span>Place </h6>
                                                        <input type="text" class="form-control" placeholder="Place" onChange={(e) => setStaffplace(e.target.value)} />
                                                    </div>

                                                    <div class="col-sm-4 mt-2 mt-sm-0">
                                                        <h6><span style={{"color":"red"}}>*</span>Pin </h6>
                                                        <input type="text" class="form-control" pattern="[0-9\-\+\s]+" minLength="6" maxLength="6"
                                                            onChange={(e) => setStaffpincode(e.target.value)} placeholder="pin" />
                                                    </div>
                                                    <div class="col-sm-6 mt-2 mt-sm-0">
                                                        <h6><span style={{"color":"red"}}>*</span>Country </h6>
                                                        <select
                                                            className="form-control select"
                                                            name="Country"
                                                            onChange={e => { changeTitle(e.target.value); setStaffcountry(e.target.value) }}

                                                        >
                                                            <option value="" disabled selected>
                                                                Select
                                                            </option>
                                                            {cntry_name}
                                                        </select>
                                                    </div>
                                                    <div class="col-sm-6 mt-2 mt-sm-0">
                                                        <h6><span style={{"color":"red"}}>*</span>State </h6>
                                                        <select
                                                            className="form-control select"
                                                            name="State"

                                                            onChange={e => { changeDistricts(e.target.value); setStaffstate(e.target.value) }}
                                                        >
                                                            <option value="" disabled selected>
                                                                Select
                                                            </option>
                                                            {state_name}

                                                        </select>
                                                    </div>
                                                    <div class="col-sm-6 mt-2 mt-sm-0">
                                                        <h6><span style={{"color":"red"}}>*</span>District </h6>
                                                        <select
                                                            className="form-control select"
                                                            name="District"
                                                            onChange={(e) => setStaffdistrict(e.target.value)}
                                                        >
                                                            <option value="" disabled selected>
                                                                Select
                                                            </option>
                                                            {district_name}
                                                        </select>
                                                    </div>
                                                    <div class="col-sm-6 mt-2 mt-sm-0">
                                                        <h6><span style={{"color":"red"}}>*</span>Branch </h6>
                                                        <select
                                                            className="form-control select"
                                                            name="Branch"
                                                            onChange={(e) => setStaffbranch(e.target.value)}
                                                        >
                                                            <option value="" disabled selected>
                                                                Select
                                                            </option>
                                                            {branch_name}
                                                        </select>
                                                    </div>



                                                </div>

                                            </div>
                                        </div>

                                    </div>


                                </div>


                            </div>
                            <div class="col-12 offset-5" style={{ "paddingLeft": "70px", "marginTop": "25px" }}>
                                <button type="submit" class="btn btn-primary mb-2" >Submit</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    )
}
